module.exports = __webpack_public_path__ + "img/人脸机 (2).4bf45320.jpg";